import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Comment } from '../../types/types'

const commentSlice = createSlice({
    name: 'comment',
    initialState: null satisfies Comment | null as Comment | null,
    reducers: {
        activeCommentSet: (_state, action: PayloadAction<Comment | null>) => {
            return action.payload;
        }
    }
})

export const { activeCommentSet } = commentSlice.actions;
export default commentSlice.reducer;
